// react and mui stuff
import { useNavigate } from "react-router-dom"

import Tooltip from "@mui/joy/Tooltip"
import Typography from "@mui/joy/Typography"
import { useColorScheme } from "@mui/joy/styles"

// data and stuff
import { Badge, BaseUserProfile, CliUser } from "../../types/users"
import useBreakpoint from "../../utils/breakpoint"
import extraBadges from "../../data/extrabadges"
import { imgSrc } from "../../utils/backend"
import { useState } from "react"
import { AspectRatio, DialogContent, DialogTitle, Modal, ModalClose, ModalDialog } from "@mui/joy"


type props = {
  currentUser: BaseUserProfile|CliUser
}

const BADGE_SIZE = 95;
const BORDER_SIZE = 2;
const CELL_PADDING = 6;

type CellProps = {
  item: Badge
  color: typeof colors["dark"]
  nav: Function
  setViewing: Function
}
function Cell({item, color, nav, setViewing}: CellProps) {

  const style = {
    width: BADGE_SIZE + CELL_PADDING + BORDER_SIZE * 2,
    height: BADGE_SIZE + CELL_PADDING + BORDER_SIZE * 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: color.background,
    border: `${BORDER_SIZE}px solid ${color.border}`,
    cursor: "pointer"
  };


  if (!item || item.name === "") return <div style={{...style, cursor: "default"}}/>
  
  const sortButton = item.image === "house_none.png";
  return (
    <div style={style} onClick={() => {
      if (sortButton) nav("/daedalus3");
      else setViewing(item)
    }}>
      <Tooltip title={item.name}>
        <img src={imgSrc(`badges/${item.image}`)}
          height={BADGE_SIZE}
          width={BADGE_SIZE}
          alt={item.name}
        />
      </Tooltip>
    </div>
  )
}

const colors = {
  light: { border: "#402a23", background: "sandybrown" },
  dark: { border: "sandybrown", background: "#402a23" }
};

export default function Badges({ currentUser }: props) {
  const [viewing, setViewing] = useState<Badge>();
  const breakpoint = useBreakpoint().getBreakPointName();
  const scheme = useColorScheme();
  const nav = useNavigate();

  const color = colors[scheme.mode === "dark" ? "dark" : "light"];
  const badges = currentUser.badges ?? []
  
  const sizes = [2, 3, 4, 6, 9];
  const columns = Math.min(sizes[breakpoint], badges.length);
  const rows = Math.ceil(badges.length / columns);
  const cells = badges.concat(extraBadges((columns * rows) - badges.length));
  
  if (badges.length === 0) return (
    <div>
      <Typography>
        Looks like {currentUser.displayName} doesn't have any badges yet!
      </Typography>
    </div>
  )

  const shelfStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    width: columns * (BADGE_SIZE + CELL_PADDING + BORDER_SIZE * 2) + BORDER_SIZE * 4,
    border: `${BORDER_SIZE * 2}px solid ${color.border}`,
    marginLeft: "auto",
    marginRight: "auto"
  }

  const Foot = () => <div style={{ width: BORDER_SIZE * 4, height: BORDER_SIZE * 4, backgroundColor: color.border }}/>

  return (
    <div>
      <Modal open={!!viewing} onClose={() => setViewing(undefined)}>
        {
          viewing ?
          <ModalDialog sx={{ maxWidth: "100%" }}>
            <ModalClose variant="plain" sx={{ m: 1 }} />
            <DialogTitle>{viewing.name}</DialogTitle>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <br/>
              <AspectRatio ratio="1" sx={{ width: BADGE_SIZE * 2, maxWidth: "100%" }}>
                <img src={imgSrc(`badges/${viewing.image}`)}
                  height={BADGE_SIZE * 2}
                  width={BADGE_SIZE * 2}
                  alt={viewing.name}
                  style={{ maxWidth: "100%", aspectRatio: "1:1" }}
                />
              </AspectRatio>
              <DialogContent sx={{ width: BADGE_SIZE * 2, maxWidth: "100%", justifyContent: "center"}}>{viewing.lore}</DialogContent>
            </div>
          </ModalDialog>
          : <div/>
        }
      </Modal>
      <div style={shelfStyle}>
        {cells.map(cell => (
          <Cell item={cell} key={cell.image} color={color} nav={nav} setViewing={setViewing}/>
        ))}
      </div>
      <div style={{
        ...shelfStyle,
        border: undefined,
        justifyContent: "space-between"
      }}>
        <Foot/>
        <Foot/>
      </div>
    </div>
  )

}